import { createModel } from "@@/package/utils/ModelUtil";
import Model from "@@/package/mapper/Model";

export class PageModel<T> extends Model {
  constructor(
      public data: T[] = [],
      public last: boolean = true,
      public pageNumber: number = 0,
      public totalElementCount: number = 0
  ) {
    super();
  }

  public static create<T>(
      pageData?: PageModel<T>,
      create?: (item: T) => T
  ): PageModel<T> {
    if (create && pageData) {
      pageData.data = pageData?.data.map(item => create(item));
    }
    // @ts-ignore
    return createModel<PageModel<T>>(PageModel, pageData);
  }
}
